import { getAnalytics, logEvent, setUserId, setUserProperties, Analytics } from 'firebase/analytics';
import { app } from '~/initializeStore';

import {
  AnalyticsProperties,
  AnalyticsService,
  AnalyticsUserProperties,
} from '@akademiasaas/shared';

export class NoOpAnalyticsService implements AnalyticsService {
  track(_event_name: string, _properties?: AnalyticsProperties): void {}
  identify(_userId: string, _userProperties?: AnalyticsUserProperties): void {}
  updateUserProperties(_userId: string, _userProperties: AnalyticsUserProperties): void {}
}

export class WebAnalyticsService implements AnalyticsService {
  analytics: Analytics;

  constructor() {
    this.analytics = getAnalytics(app);
  }

  track(event_name: string, properties?: AnalyticsProperties): void {
    logEvent(this.analytics, event_name, properties);
  }

  identify(userId: string, userProperties?: AnalyticsUserProperties) {
    setUserId(this.analytics, userId);
    setUserProperties(this.analytics, {
      email: userProperties?.email || null,
      name: userProperties?.name || null,
    });
  }

  updateUserProperties(userId: string, userProperties: AnalyticsUserProperties): void {
    setUserProperties(this.analytics, { userId, email: userProperties.email || null });
  }
}
